import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { SelectOption } from '@/shared/types';
import type { JsonPatchOperation } from '@/shared/types/common';

import type { TagItem } from '@/entities/tags';

export const updateEntityTags = async (
  endpoint: string,
  newTagFQNs: string[],
  availableTags: SelectOption<string>[],
  currentTags: TagItem[]
): Promise<void> => {
  const operations: JsonPatchOperation[] = [];
  const existingGlossaryTags = currentTags.filter((tag) => tag.source === 'Glossary');

  const newClassificationTags = newTagFQNs.flatMap((tagFQN) => {
    const tag = availableTags.find((t) => t.value === tagFQN);
    return tag ? [{ tagFQN }] : [];
  });

  const allTags = [...existingGlossaryTags, ...newClassificationTags];

  if (currentTags.length > 0) {
    operations.push({
      op: 'replace',
      path: '/tags',
      value: allTags,
    });
  } else {
    operations.push({
      op: 'add',
      path: '/tags',
      value: allTags,
    });
  }

  if (operations.length > 0) {
    await openMetadataApiClient.patch(endpoint, operations, {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    });
  }
};
